import { ImportEmailListPage } from '@online-webinar/management';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/marketing/import'].update({
        staticData: { title: { page: 'EmailLists.Import.PageHeading', forWebinar: true } },
        component: authGuard(ImportEmailListPage, { isWhitelabel: true, canManageEmailLists: true, canBroadcast: true })
    });
};
